import { AUTH, LOGOUT } from "../constants/actionTypes";
const storedAuth = localStorage.getItem("profile");

const initialState = {
    authData: storedAuth ? JSON.parse(storedAuth) : null,
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH:
            return { ...state, authData: action?.data };
        case LOGOUT:
            localStorage.removeItem("profile"); // remove it on logout
            return { ...state, authData: null };
        default:
            return state;
    }
};
